import { PrescriptionMedicineStruct } from "./prescription-medicine.struct";
import { PrescriptionSolutionStruct } from "./prescription-solution.struct";

export class AuxStandardPrescriptionStruct {
    public prescriptionMedicineStruct: PrescriptionMedicineStruct = new PrescriptionMedicineStruct();
    public prescriptionSolutionStruct: PrescriptionSolutionStruct = new PrescriptionSolutionStruct();
}